import axios from 'axios';

export const API_BASE_URL = process.env.VUE_APP_API_URL || `${window.location.origin}`;
export const SOCKET_URL = process.env.VUE_APP_SOCKET_URL || API_BASE_URL;
export const STREAM_HOST = process.env.VUE_APP_STREAM_HOST || 'crs.vogroup.agency';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('username');
      localStorage.removeItem('userId');
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
